module.exports = __webpack_public_path__ + "static/media/about__frame.6b10072d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pages/about/about__frame.jpg
// module id = 202
// module chunks = 0